
<mat-form-field>
  <mat-select [disabled]="disabled" [formControl]="teamCtrl" placeholder="Select Teams" multiple (closed)="setTeams()">
    <mat-option>
      <ngx-mat-select-search [formControl]="teamFilterCtrl"
        placeholderLabel="Find team..."
      noEntriesFoundLabel="no matching team found"></ngx-mat-select-search>
    </mat-option>
    <mat-select-trigger>
      {{teamCtrl.value && teamCtrl.value.length >= 1 ? teamCtrl.value[0].name : 'None Selected'}}
      @if (teamCtrl.value?.length > 1) {
        <span class="example-additional-selection">
          (+{{teamCtrl.value.length - 1}} {{teamCtrl.value?.length === 2 ? 'other' : 'others'}})
        </span>
      }
    </mat-select-trigger>
    @for (team of filteredTeams | async; track team) {
      <mat-option
        [value]="team"
        [matTooltip]="team.allTeamUsersTooltip"
        matTooltipPosition="left"
        >
        {{team.name}}
      </mat-option>
    }
  </mat-select>
</mat-form-field>

@if (displayTeamList) {
  @if (removableSelectionList) {
    <div class="selected-items">
      <h5>Selected teams</h5>
      @if (teamCtrl.value?.length) {
        <ul class="list">
          @for (team of teamCtrl.value; track team) {
            <li>
              <span>{{team.name}}</span>
              <button type="button" class="selection-remove" (click)="removeTeam(team)" [attr.aria-label]="'Remove ' + team.name">
                <mat-icon>close</mat-icon>
              </button>
            </li>
          }
        </ul>
      } @else {
        <p class="selection-empty">No teams selected</p>
      }
    </div>
  } @else {
    <div class="row">
      <div class="col-12">
        <h5>Selected Teams:</h5>
        <ul class="list">
          @for (team of teamCtrl.value; track team) {
            <li>{{team.name}}</li>
          }
        </ul>
      </div>
    </div>
  }
}
